document.addEventListener('alpine:init', () => {
    Alpine.data('purlinScene', () => ({
        getPurlinModel() {
            return window.WBApp.utils.getPurlinModel(
                +this.lL,
                this.lMid,
                +this.lR,
                +this.purlinL,
                +this.hC,
                +this.cS,
                this.supports,
                this.hasStruts,
                this.xHinges
            );
        },

        updatePurlinScene() {
            this.updateXHinges();
            this.purlinL = (+this.lL + this.lMid.reduce((a, b) => +a + +b, 0) + +this.lR).toFixed(2);
            this.purlinViewer.loadModel(this.getPurlinModel());
        },

        updateXHinges() {
            this.xHinges = [...this.xHingesUser];
            if (this.hasHingesAtJoints) {
                let x = this.lL;
                for (let i = 0; i < this.lMid.length - 1; i++) {
                    x += +this.lMid[i];
                    this.xHinges.push(x);
                }
            }
        },

        init() {
            const canvas = document.getElementById('roof-purlin-scene');
            this.purlinViewer = new window.WBApp.utils.Viewer(canvas);
            this.purlinViewer.config.updateSettings({
                showGrid: false,
                showOrigin: false,
                showNodeLabels: false,
                showMemberLabels: false,
            });

            this.$watch('roofType', (type) => {
                if (type.includes('vaznice')) {
                    setTimeout(() => {
                        this.updatePurlinScene();
                    }, 500);
                }
            });
        },
    }));
});